import React, { useState } from 'react';
import { AssessmentType } from '../types';
import DassAssessment from './assessments/DassAssessment';
import BrsAssessment from './assessments/BrsAssessment';
import CissAssessment from './assessments/CissAssessment';
import { ClipboardCheck, Brain, Target } from 'lucide-react';

const Assessment: React.FC = () => {
  const [selectedAssessment, setSelectedAssessment] = useState<AssessmentType | null>(null);

  if (!selectedAssessment) {
    return (
      <div className="flex flex-col h-full">
        <div className="bg-white rounded-xl shadow-lg p-6 flex-1 overflow-y-auto">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Choose Assessment Type</h2>
          
          <div className="grid grid-cols-1 gap-4 max-w-2xl mx-auto">
            <button
              onClick={() => setSelectedAssessment('dass')}
              className="p-6 rounded-xl border-2 border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-all group"
            >
              <div className="flex items-center mb-3">
                <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center group-hover:bg-blue-100">
                  <ClipboardCheck className="w-6 h-6 text-blue-500" />
                </div>
                <h3 className="text-lg font-semibold ml-4">Emotional Assessment</h3>
              </div>
              <p className="text-gray-600 text-left">
                Evaluate your emotional state over the past week, including stress, anxiety, and depression levels.
              </p>
            </button>

            <button
              onClick={() => setSelectedAssessment('brs')}
              className="p-6 rounded-xl border-2 border-gray-200 hover:border-purple-300 hover:bg-purple-50 transition-all group"
            >
              <div className="flex items-center mb-3">
                <div className="w-12 h-12 rounded-xl bg-purple-50 flex items-center justify-center group-hover:bg-purple-100">
                  <Brain className="w-6 h-6 text-purple-500" />
                </div>
                <h3 className="text-lg font-semibold ml-4">Resilience Scale (BRS)</h3>
              </div>
              <p className="text-gray-600 text-left">
                Assess your ability to bounce back from stress and adversity.
              </p>
            </button>

            <button
              onClick={() => setSelectedAssessment('ciss')}
              className="p-6 rounded-xl border-2 border-gray-200 hover:border-indigo-300 hover:bg-indigo-50 transition-all group"
            >
              <div className="flex items-center mb-3">
                <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center group-hover:bg-indigo-100">
                  <Target className="w-6 h-6 text-indigo-500" />
                </div>
                <h3 className="text-lg font-semibold ml-4">Coping Style Scale (CISS)</h3>
              </div>
              <p className="text-gray-600 text-left">
                Evaluate your preferred strategies for dealing with stress.
              </p>
            </button>
          </div>
        </div>
      </div>
    );
  }

  switch (selectedAssessment) {
    case 'dass':
      return <DassAssessment onBack={() => setSelectedAssessment(null)} />;
    case 'brs':
      return <BrsAssessment onBack={() => setSelectedAssessment(null)} />;
    case 'ciss':
      return <CissAssessment onBack={() => setSelectedAssessment(null)} />;
  }
};

export default Assessment;